// Typ: FindCircleCircumferenceFromRadiusTask
// Temat: Okrąg i koło → Elementy, długości i pola → Długość okręgu
// Wzór:  L = 2πr  (używamy L jak w karcie wzorów)

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import PiInput, {
  parsePiLikeInput,
  formatPiValueLatex,
} from "../../../../components/inputs/PiInput";

// ...importy bez zmian
const DEC_TOL = 0.1;
const DEBUG = true; // <— włącz/wyłącz logi

export function generateTask() {
  const r = Math.floor(Math.random() * 9) + 2;
  return { type: "FindCircleCircumferenceFromRadiusTask", data: { r } };
}

export function renderTask({ data }) {
  const { r } = data;
  return (
    <div style={{ marginTop: 16, marginBottom: 8 }}>
      Dany jest okrąg o promieniu <InlineMath math={`r=${r}`} />.
      Oblicz jego długość (obwód) <InlineMath math={"L"} />.
    </div>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  if (DEBUG) console.log("[CIRC renderInput] value=", userAnswer);
  return (
    <PiInput
      value={userAnswer}
      onChange={(v) => {
        if (DEBUG) console.log("[CIRC onChange] PiInput ->", v);
        onChange(v);
      }}
      disabled={disabled}
      label={"L"}
      placeholder="np. 10π, 3/2π, π/2 lub 31.4 (±0.1)"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const { r } = data;
  const expected = 2 * Math.PI * r;

  const parsed =
    typeof userAnswer === "object" && userAnswer?.parsed != null
      ? userAnswer.parsed
      : parsePiLikeInput(
          typeof userAnswer === "object" ? userAnswer.raw : userAnswer
        );

  if (DEBUG)
    console.log("[CIRC checkAnswer]", {
      r,
      expected,
      userAnswer,
      parsed,
      ok: parsed != null && Math.abs(parsed - expected) <= DEC_TOL,
    });

  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - expected) <= DEC_TOL;
}

export function renderAnswer({ data }) {
  const { r } = data;
  const k = 2 * r;
  const exact = k === 1 ? "\\pi" : `${k} \\pi`;
  return (
    <div style={{ marginTop: 6 }}>
      <InlineMath math={`L = ${exact}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (DEBUG) console.log("[CIRC renderUserAnswer] incoming=", userAnswer);
  const raw = typeof userAnswer === "object" ? userAnswer?.raw : userAnswer;
  if (DEBUG) console.log("[CIRC renderUserAnswer] raw=", raw);

  if (!raw || typeof raw !== "string" || raw.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }
  const pretty = formatPiValueLatex(raw);
  if (DEBUG) console.log("[CIRC renderUserAnswer] formatted=", pretty);
  return (
    <div style={{ marginTop: 6 }}>
      <InlineMath math={`L = ${pretty || "\\text{—}"}`} />
    </div>
  );
}

export function renderExplanation({ data }) {
  const { r } = data;
  const k = 2 * r;
  const approx = (2 * Math.PI * r).toFixed(2);
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <div><strong>Krok 1.</strong> Długość okręgu:</div>
      <BlockMath math={"L = 2\\pi r"} />
      <div><strong>Krok 2.</strong> Podstawiamy <InlineMath math={`r=${r}`} />:</div>
      <BlockMath math={`L = 2\\cdot \\pi \\cdot ${r} = ${k}\\,\\pi`} />
      <div><strong>Krok 3.</strong> (Opcjonalnie) Przybliżenie:</div>
      <BlockMath math={`L \\approx ${approx}`} />
    </div>
  );
}
